export const PDF_EXPORT_DOWNLOAD_FORBIDDEN_MESSAGE =
    'Only the person who requested this download can open it. You can request your own copy using Download PDF.';

export const PDF_EXPORT_DOWNLOAD_NOT_FOUND_MESSAGE =
    'This download could not be found. You can request a new copy using Download PDF.';

export const PDF_EXPORT_DOWNLOAD_UNAUTHORIZED_MESSAGE =
    'Unable to download the requested file. Please log in to your account to access it';

export const PDF_EXPORT_DOWNLOAD_GENERIC_ERROR_MESSAGE =
    'Something went wrong while downloading';

export const getPdfExportDownloadErrorMessage = (status) => {
    if (status === 401) {
        return PDF_EXPORT_DOWNLOAD_UNAUTHORIZED_MESSAGE;
    }
    if (status === 403) {
        return PDF_EXPORT_DOWNLOAD_FORBIDDEN_MESSAGE;
    }
    if (status === 404) {
        return PDF_EXPORT_DOWNLOAD_NOT_FOUND_MESSAGE;
    }

    return PDF_EXPORT_DOWNLOAD_GENERIC_ERROR_MESSAGE;
};
